export function getSignButtonText(opts: { isInitials: boolean; isSigned: boolean }): string {
  const { isInitials, isSigned } = opts;
  if (isSigned) return isInitials ? 'Clear Initials' : 'Clear Signature';
  return isInitials ? 'Initial Here' : 'Sign Here';
}

/** Prompt inside the empty state of an unsigned signature/initials field. */
export function getSignaturePlaceholderLabel(opts: {
  isInitials: boolean;
  isSigning: boolean;
}): string {
  const { isInitials, isSigning } = opts;
  if (isSigning) return isInitials ? 'Click to initial' : 'Click to sign';
  return isInitials ? 'Edit initials' : 'Click to edit signature';
}

/** Label beside the top bracket stub of a signature/initials frame. */
export function getStampTopLabel(isInitials: boolean): string {
  return isInitials ? 'Initial' : 'Signature';
}

/** Brand mark beside the bottom bracket stub of every signature/initials frame. */
export const STAMP_BOTTOM_LABEL = 'AlineSign';
